
import React, { useState, useEffect } from "react";
import "./near-by-store.scss";
import { getDistanceNew, shopBackgrounds } from "../../../components/common/utils";
import CardDesignShadow from "../../../images/home/card-design-shadow.svg";

const NearbyStores = ({ sellers, navigate, categoryParam }) => {
  const [shuffledBackgrounds, setShuffledBackgrounds] = useState([]);
  const defaultAddress = JSON.parse(localStorage.getItem("defaultAddress"));
  const [distances, setDistance] = useState("")
  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  const handleSellerClick = (seller, categoryParam, navigate, sellers) => {
    const encodedValue = encodeURIComponent(seller?.providerId);
    const encodedCategoryName = encodeURIComponent(categoryParam);
    navigate(`/seller?pid=${encodedValue}&category=${encodedCategoryName}`, {
      state: {
        category: categoryParam || "All",
        sellers: sellers
      },
    });
  };

  useEffect(() => {
    setShuffledBackgrounds(shuffleArray(shopBackgrounds));
  }, []);

  // const storeDistance = async(store) => {
  //   let distance = ""
  //   if (store?.distance >= 0) {
  //     distance = `${store?.distance.toFixed(2)} Km`
  //   }
  //   else if (store?.locations?.length) {
  //     const [sellerLat, sellerLon] = store?.locations?.[0]?.gps?.split(',').map(Number);
  //     const defaultLat = parseFloat(
  //       defaultAddress?.latitude
  //     );
  //     const defaultLon = parseFloat(
  //       defaultAddress?.longitude
  //     );
  //     const dist = await getDistance(
  //       defaultLat,
  //       defaultLon,
  //       sellerLat,
  //       sellerLon
  //     )
  //     console.log(dist,'dist')
  //     distance = `${dist.toFixed(2)} Km`
  //   }
  //   else {
  //     distance = "Distance not available"
  //   }
  //   return distance;
  // }

  useEffect(() => {
    async function calculateDistances() {
      if (!sellers?.length) return;

      const updated = await Promise.all(
        sellers.map(async (store) => {
          // Already present
          if (store?.distance >= 0) {
            return {
              ...store,
              distanceKM: `${store.distance.toFixed(2)} Km`,
            };
          }

          // Use store location if available
          if (store?.locations?.length) {
            const [sellerLat, sellerLon] = store.locations[0]?.gps
              ?.split(",")
              .map(Number);

            const defaultLat = parseFloat(defaultAddress?.latitude);
            const defaultLon = parseFloat(defaultAddress?.longitude);

            const dist = await getDistanceNew(defaultLat, defaultLon, sellerLat, sellerLon);
            return {
              ...store,
              distanceKM: `${dist.toFixed(2)} Km`,
            };
          }

          return { ...store, distanceKM: "Distance not available" };
        })
      );

      setDistance(updated);
    }

    calculateDistances();
  }, [sellers]);

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="near-by-stor-container-kl">
            <div className="near-by-stor-list-kl">
              {sellers?.map((store, index) => {
                const panIndia = store?.serviceabilityRadius?.some(item => item.type === "12");
                const randomBg = panIndia ? store?.photo : shuffledBackgrounds[index % shuffledBackgrounds.length]
                return (
                  <div onClick={() => handleSellerClick(store, categoryParam, navigate, sellers)} key={store?._id} className="near-by-stor-item-kl">
                    <div className="near-by-stor-card-kl">
                      {!panIndia && <div className="near-by-stor-card-circle-kl">
                        <img src={store?.photo ?? ""} alt="" />
                      </div>}
                      <div className="near-by-stor-card-header-kl">
                        <div className="near-by-stor-card-img-kl">
                          <img src={randomBg} alt="" />
                        </div>
                        <img className="card-design-shadow" src={CardDesignShadow} alt={`Exciting offer ${index + 1}`} />
                      </div>
                      <div className="near-by-stor-card-footer-kl">

                        <div className="near-by-stor-card-title-kl">{store?.name ?? ""}</div>
                        <div className="near-by-stor-card-store-km-kl">
                          {distances?.distanceKM}
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NearbyStores;